import React from 'react'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane/Pane'
import styled from 'styled-components'
import { rem } from 'polished'

const Root = styled(Pane)`
  width: ${rem(360)};
  display: grid;
  grid-template-columns: ${rem(100)} 1fr;
  min-height: ${rem(136)};
  padding: ${rem(8)};
  height: 100%;
  overflow: hidden;
  box-shadow: none;

  &.tile-border {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
    border-radius: ${props => props.theme.borderRadius.XS};
  }
`

const ImageBox = styled(LoadingBox)`
  height: ${rem(120)};
  width: ${rem(100)};
`

const TitleBox = styled(LoadingBox)`
  height: ${rem(20)};
  margin: 0 0 0 ${rem(6)};
`

const RatingBox = styled(LoadingBox)`
  height: ${rem(24)};
  padding: 0 ${rem(6)};
  margin: 0 0 0 ${rem(6)};
`

const PriceBox = styled(LoadingBox)`
  height: ${rem(40)};
  padding: 0 ${rem(6)};
  margin: ${rem(36)} 0 0 ${rem(6)};
`

function CustomersViewedAndBookedSkeleton() {
  return <Root>
    <LoadingBox data-testid="customers-viewed-and-booked-skeleton">
      <ImageBox/>
    </LoadingBox>
    <Group direction="vertical" fullWidth gap={4}>
      <TitleBox/>
      <RatingBox/>
      <PriceBox/>
    </Group>
  </Root>
}

export default CustomersViewedAndBookedSkeleton
